export function CheckIcon({ className }: { className?: string }) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="M8.99906 20.4228L2.78906 14.2128L5.61906 11.3828L8.99906 14.7728L18.8791 4.88281L21.7091 7.71281L8.99906 20.4228Z"
				fill="#00AB89"
			/>
		</svg>
	);
}
